import {
  GET_CARRIER_INFOS_IN_PROGRESS,
  GET_CARRIER_INFOS_SUCCESS,
  GET_CARRIER_INFOS_FAIL,
  POST_CARRIER_IN_PROGRESS,
  POST_CARRIER_SUCCESS,
  POST_CARRIER_FAIL,
  PUT_CARRIER_IN_PROGRESS,
  PUT_CARRIER_SUCCESS,
  PUT_CARRIER_FAIL,
  RESET_CARRIER,
} from "../constants";

const initialState = {
  infos: undefined,
  saving: false,
  saved: false,
  errors: null,
};

/**
 * Carrier reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function carrier(state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_CARRIER_INFOS_IN_PROGRESS:
      return {
        ...state,
        infos: undefined,
      };

    case GET_CARRIER_INFOS_SUCCESS:
      return {
        ...state,
        infos: payload.infos,
      };

    case GET_CARRIER_INFOS_FAIL:
      return {
        ...state,
        infos: null,
      };

    case POST_CARRIER_IN_PROGRESS:
    case PUT_CARRIER_IN_PROGRESS:
      return {
        ...state,
        saving: true,
        saved: false,
        errors: null,
      };

    case POST_CARRIER_SUCCESS:
    case PUT_CARRIER_SUCCESS:
      return {
        ...state,
        saving: false,
        saved: true,
      };

    case POST_CARRIER_FAIL:
    case PUT_CARRIER_FAIL:
      return {
        ...state,
        saving: false,
        saved: false,
        errors: payload.violations,
      };

    case RESET_CARRIER:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
}
